import { Phone, PhoneCall, PhoneMissed, ThumbsUp, ThumbsDown, Voicemail, XCircle, Calendar, UserX } from 'lucide-react';

/**
 * L'icone de chaque resultat d'appel, dans le menu de qualification.
 *
 * Elle vivait en haut de ProspectDetailPanel ; l'onglet Historique, qui est
 * le seul a s'en servir, en a besoin depuis son propre fichier.
 */
export const DISPOSITION_ICONS = {
    contacted: Phone,
    callback_requested: PhoneCall,
    interested: ThumbsUp,
    not_interested: ThumbsDown,
    voicemail: Voicemail,
    no_answer: PhoneMissed,
};